import { render, staticRenderFns } from "./hospitalTab.vue?vue&type=template&id=6ed11360&scoped=true&"
import script from "./hospitalTab.vue?vue&type=script&lang=js&"
export * from "./hospitalTab.vue?vue&type=script&lang=js&"
import style0 from "./hospitalTab.vue?vue&type=style&index=0&id=6ed11360&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed11360",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/royalbeeseg.com/Demo-4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ed11360')) {
      api.createRecord('6ed11360', component.options)
    } else {
      api.reload('6ed11360', component.options)
    }
    module.hot.accept("./hospitalTab.vue?vue&type=template&id=6ed11360&scoped=true&", function () {
      api.rerender('6ed11360', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/partial/product/info-tabs/hospitalTab.vue"
export default component.exports